var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHexagons02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 215.9 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -2390.67,
    y1: -5472.05,
    x2: -1960.06,
    y2: -5472.05,
    gradientTransform: "matrix(0, 1, 1, 0, 5671.35, 2547.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#067eb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006391"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -2363.89,
    y1: -5472.05,
    x2: -2396.06,
    y2: -5472.05,
    gradientTransform: "matrix(0, 1, 1, 0, 5671.35, 2547.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18c3fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009de6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -2396.18,
    y1: -5286.07,
    x2: -1926.06,
    y2: -5286.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -2366.94,
    y1: -5286.07,
    x2: -2402.06,
    y2: -5286.07,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -2444.86,
    y1: -5411.7,
    x2: -1990.01,
    y2: -5411.7,
    gradientTransform: "matrix(0, 1, 1, 0, 5671.35, 2547.06)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#067eb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#006391"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -2357.05,
    y1: -5411.7,
    x2: -2446.06,
    y2: -5411.7,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -2413.89,
    y1: -5337.7,
    x2: -2065.25,
    y2: -5337.7,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -2346.58,
    y1: -5337.7,
    x2: -2414.81,
    y2: -5337.7,
    xlinkHref: "#linear-gradient-2"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "hexagons02") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mid"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.72,586.3l11.46-8.11a6.88,6.88,0,0,0,1.42-4.54V173.87a6.87,6.87,0,0,0-1.42-4.53l-11.46-12.25a1.78,1.78,0,0,0-2.84,0l-11.46,12.25a6.87,6.87,0,0,0-1.42,4.53V573.65a6.88,6.88,0,0,0,1.42,4.54l11.46,8.11A1.79,1.79,0,0,0,200.72,586.3Z",
    transform: "translate(-185 -101)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200.72,182.79l11.46-6.63a2.82,2.82,0,0,0,1.42-2.46V160.47a2.89,2.89,0,0,0-1.42-2.47l-11.46-6.62a2.83,2.83,0,0,0-2.84,0L186.42,158a2.83,2.83,0,0,0-1.42,2.47V173.7a2.87,2.87,0,0,0,1.42,2.46l11.46,6.63A2.88,2.88,0,0,0,200.72,182.79Z",
    transform: "translate(-185 -101)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M386.83,620.23l12.52-8.85a7.54,7.54,0,0,0,1.55-5V170a7.54,7.54,0,0,0-1.55-4.95l-12.52-13.37a1.93,1.93,0,0,0-3.09,0L371.22,165a7.54,7.54,0,0,0-1.55,4.95V606.43a7.54,7.54,0,0,0,1.55,5l12.52,8.85A1.93,1.93,0,0,0,386.83,620.23Z",
    transform: "translate(-185 -101)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M386.83,179.71l12.52-7.24a3.11,3.11,0,0,0,1.55-2.69V155.33a3.15,3.15,0,0,0-1.55-2.68l-12.52-7.24a3.1,3.1,0,0,0-3.09,0l-12.52,7.24a3.09,3.09,0,0,0-1.55,2.68v14.45a3.16,3.16,0,0,0,1.55,2.69l12.52,7.24A3.15,3.15,0,0,0,386.83,179.71Z",
    transform: "translate(-185 -101)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M263.58,556l31.74-17.67a7.54,7.54,0,0,0,3.93-6.55V127.42a7.53,7.53,0,0,0-3.93-6.54l-31.74-17.67a8.09,8.09,0,0,0-7.84,0L224,120.86a7.52,7.52,0,0,0-3.93,6.56v404.4a7.54,7.54,0,0,0,3.93,6.55L255.72,556A8.13,8.13,0,0,0,263.58,556Z",
    transform: "translate(-185 -101)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M263.58,189l31.74-18.34a7.85,7.85,0,0,0,3.93-6.79V127.17a7.85,7.85,0,0,0-3.93-6.79L263.58,102a7.89,7.89,0,0,0-7.84,0L224,120.38a7.85,7.85,0,0,0-3.93,6.79v36.67a7.85,7.85,0,0,0,3.93,6.79L255.72,189A7.93,7.93,0,0,0,263.58,189Z",
    transform: "translate(-185 -101)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M336.66,481,361,467.48a5.76,5.76,0,0,0,3-5v-310a5.78,5.78,0,0,0-3-5l-24.33-13.54a6.23,6.23,0,0,0-6,0l-24.34,13.53a5.77,5.77,0,0,0-3,5v310a5.76,5.76,0,0,0,3,5L330.64,481A6.25,6.25,0,0,0,336.66,481Z",
    transform: "translate(-185 -101)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M336.66,199.67l24.33-14a6,6,0,0,0,3-5.21v-28.1a6,6,0,0,0-3-5.21l-24.33-14a6,6,0,0,0-6,0l-24.34,14a6,6,0,0,0-3,5.21v28.1a6,6,0,0,0,3,5.21l24.33,14A6,6,0,0,0,336.66,199.67Z",
    transform: "translate(-185 -101)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagons02);
export default __webpack_public_path__ + "static/media/hexagons02.c40297b99a08cf88529116ae2eafd587.svg";
export { ForwardRef as ReactComponent };